import { TabFields } from '@cmhc-schl/hearth-ui';
import {
  approvedLender,
  RemarkDetail
} from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/HbtPortfolioLoansInventoryTable/types';
import { TFunction } from 'i18next';
import { ToastNotificationConfig } from '../HbtMasterPoolDetails/types';
import { Dispatch, SetStateAction } from 'react';

export interface HbtMasterPoolLoansInventoryProps {
  masterPoolAccountNumber: string;
  handleViewLoanDetailsActionRowClick: (tabList: TabFields) => void;
  handleMutipleLoanDetailsActionClick: (tabList: TabFields[]) => void;
  setMasterPoolNotification?: (show: boolean) => void;
  setNotificationBannerConfig?: Dispatch<SetStateAction<ToastNotificationConfig>>;
  setIsForceStatusTriggered?: (isTriggered: boolean) => void;
}

export interface UnderwritingApprovedLenderName {
  englishName: string;
  frenchName: string;
}

interface StatusHistoryDetail {
  originalAccountStatusTypeCode?: string;
  recordCreatedTimestamp?: string;
  recordCreatedUserID?: string;
}
interface RemarksDetail {
  remarkId?: number;
  remarkText?: string;
  recordCreatedTimestamp?: string;
  recordCreatedUserID?: string;
  firstName?: string;
  lastName?: string;
}
export interface LoanInventoryTableFields {
  loanId: string;
  cmhcAccountNumber: number;
  lenderReferenceNumber: string;
  loanStatus: string;
  propertyAddress: string;
  underwritingApprovedLenderCode: string;
  underwritingApprovedLenderName: UnderwritingApprovedLenderName;
  loanPremiumRate: number;
  errorMessageInfo?: string;
  lowRatioCmhcAccountNumber: string;
  id: string;
  portfolioId: string;
  portfolioEpipProcessingStatus: string;
  lowRatioAccountNumber: string;
  insuredApprovedLenderCode: string;
  approvedLender?: approvedLender;
  reducedDatasetIndicator: boolean;
  remarks: RemarksDetail[];
  latestRemark?: RemarkDetail;
  statusHistory?: StatusHistoryDetail[];
  originalStatus?: string;
  riskResultOverrideIndicator?: number;
}

export type TranslationType = TFunction<'HbtMasterPool', undefined>;

export interface LoansErrorHookProps {
  errorMessageDescriptionID: string;
  errorMessageEnglish: string;
  errorMessageFrench: string;
}

export const SeverityCodes = {
  requiresReview: 'requires review',
  warning: 'warning',
  error: 'error'
} as const;

export type SeverityCode = (typeof SeverityCodes)[keyof typeof SeverityCodes];

export type MappedCodes = Record<string, LoansErrorHookProps>;
export type GroupedErrors = Partial<Record<SeverityCode, MappedCodes>>;

export type RemarkItem = {
  remarkId: number;
  remarkText: string;
  recordCreatedTimestamp: string;
  recordCreatedUserID: string;
  firstName: string;
  lastName: string;
};

export type mergedRemarkItem = RemarkItem & {
  englishRationale: string | null;
  frenchRationale: string | null;
  remarkHeader: string;
};
